import { merge } from 'ramda';
import { SUCCESS, REQUEST, FAIL } from 'src/store/actions/calendarEventsLogActions';

const initialState = {
  data: [],
  fetching: false,
  errors: []
};

const calendarEventsLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { data: action.calendarEventsLog, fetching: false, errors: [] });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default calendarEventsLogReducer;
